import { render, staticRenderFns } from "./RecaptchaTerms.vue?vue&type=template&id=bfd2a022&scoped=true"
import script from "./RecaptchaTerms.vue?vue&type=script&lang=js"
export * from "./RecaptchaTerms.vue?vue&type=script&lang=js"
import style0 from "./RecaptchaTerms.vue?vue&type=style&index=0&id=bfd2a022&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfd2a022",
  null
  
)

export default component.exports